import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';

import { LoadingIndicatorComponent } from '../components/loading-indicator/loading-indicator.component';

@Directive({
    selector: '[zciLoading]',
})
export class LoadingDirective {
    private templateRef = inject<TemplateRef<any>>(TemplateRef);
    private containerRef = inject(ViewContainerRef);

    @Input()
    set zciLoading(loading: boolean) {
        this.containerRef.clear();

        if (loading) {
            this.containerRef.createComponent<LoadingIndicatorComponent>(LoadingIndicatorComponent);
        } else {
            this.containerRef.createEmbeddedView(this.templateRef);
        }
    }
}
